import React, { Component } from 'react'
import FlickerBanner from '../Banners/FlickerBanner.js';

import './Header.css';

//for all header material
//name major github buttons etc...
export default class Header extends Component {
    render() {
        return (
            <div id = "Header">
                <FlickerBanner className = "element" name = "Jason Liu" occupation = "Computer Science Undergraduate"/>
            </div>
        );
    }
}
